import { render, staticRenderFns } from "./CurriculumSyllabusEECColumn.vue?vue&type=template&id=b0a9b226&scoped=true&"
import script from "./CurriculumSyllabusEECColumn.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusEECColumn.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSyllabusEECColumn.vue?vue&type=style&index=0&id=b0a9b226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a9b226",
  null
  
)

export default component.exports